import { createSelector } from '@reduxjs/toolkit';
import {
  selectProjectsDetails,
  selectOptionsPages, selectOptionsPlusTotal, selectOptionsPercentTotal, selectOptionsAsap,
} from '../project/projectSelectros';

export const selectEmailTemplates = createSelector(
  selectProjectsDetails,
  projectsDetails => projectsDetails?.email || {}
);

export const selectEmailTemplatesCalculationParams = createSelector(
  selectEmailTemplates,
  projectOther => projectOther.calculationOptions || {}
);

export const selectEmailTemplatesPagesTotal = createSelector(
  selectOptionsPages,
  selectEmailTemplatesCalculationParams,
    (options, {discountTemplates}) => {
      const pagesCount = options.reduce((accumulator, currentValue) => accumulator + currentValue.totalQuantity, 0);
      const totalPriceWithoutDiscount = options.reduce((accumulator, currentValue) => accumulator + currentValue.total, 0);
      const isMoreThree = pagesCount > 3;
      const discountPercent = isMoreThree ? (discountTemplates / 100) : 0;
      const totalPriceWithDiscount = totalPriceWithoutDiscount - (Math.ceil((totalPriceWithoutDiscount) * discountPercent));
      return {
          discount: 0,
          totalPages: pagesCount,
          totalPricePages: totalPriceWithDiscount
      };
    }
);

export const selectEmailTemplatesOptionsTotal = createSelector(
  selectEmailTemplatesPagesTotal,
  selectOptionsPlusTotal,
  selectOptionsPercentTotal,
  selectEmailTemplatesCalculationParams,
  ({totalPricePages, totalPages}, totalPricePlusOptions, totalPricePercentOptions, {discountTemplates}) => {
    const totalPriceOfPercent = Math.ceil((totalPricePercentOptions / 100) * totalPricePages);
    const isMoreThree = totalPages > 3;
    const discountPercent = isMoreThree ? (discountTemplates / 100) : 0;
    const totalPricePlusOptionsWithDiscount = (totalPricePlusOptions * totalPages) - (Math.ceil((totalPricePlusOptions * totalPages) * discountPercent));
    return totalPricePlusOptionsWithDiscount + totalPriceOfPercent;
  }
);

export const selectEmailTemplatesTotalForAsap = createSelector(
    selectOptionsPages,
    selectEmailTemplatesPagesTotal,
    selectOptionsPlusTotal,
    selectOptionsPercentTotal,
    (options,{totalPricePages, totalPages}, totalPricePlusOptions, totalPricePercentOptions) => {
        const totalPricePagesWithoutDiscount = options.reduce((accumulator, currentValue) => accumulator + currentValue.total, 0);
        const totalPriceOfPercent = Math.ceil((totalPricePercentOptions / 100) * totalPricePages);
        const totalPriceOptionsWithoutDiscount = (totalPricePlusOptions * totalPages) + totalPriceOfPercent;
        return totalPricePagesWithoutDiscount + totalPriceOptionsWithoutDiscount;
    }
);

export const selectEmailTemplatesDiscount = createSelector(
  selectEmailTemplatesPagesTotal,
  selectEmailTemplatesOptionsTotal,
  selectOptionsAsap,
  selectEmailTemplatesCalculationParams,
  selectEmailTemplatesTotalForAsap,
  ({totalPricePages, totalPages}, totalPriceOptions, asap, {discountTemplates}, totalPriceForAsap) => {
    const isASAP = asap.length;
    const isMoreThree = totalPages > 3;
    const discountPercent = isMoreThree ? (discountTemplates / 100) : 1;

    var totalDiscountPrice;
    if (isASAP) {
        totalDiscountPrice = Math.ceil((totalPriceForAsap * 2) * discountPercent);
    } else {
        totalDiscountPrice = totalPriceForAsap - (totalPricePages + totalPriceOptions);
    }

    return {
      discountIsExists: isMoreThree,
      discountText: `Your ${discountTemplates}% discount`,
      discountPrice: totalDiscountPrice
    };
  }
);

export const selectEmailTemplatesTotal = createSelector(
  selectEmailTemplatesPagesTotal,
  selectEmailTemplatesOptionsTotal,
  selectOptionsAsap,
  selectEmailTemplatesCalculationParams,
  selectEmailTemplatesTotalForAsap,
  ({totalPricePages, totalPages}, totalPriceOptions, asap, {discountTemplates}, totalPriceForAsap) => {
      const isASAP = asap.length;
      const isMoreThree = totalPages > 3;
      var totalForResult;

      if (isASAP) {
          const discountPercent = isMoreThree ? (discountTemplates / 100) : 0;
          totalForResult = (totalPriceForAsap * 2) - Math.ceil((totalPriceForAsap * 2) * discountPercent);
      } else {
          totalForResult = totalPricePages + totalPriceOptions;
      }

      return totalForResult;
  }
);

export const selectEmailTemplatesEta = createSelector(
  selectEmailTemplatesPagesTotal,
  selectOptionsAsap,
  ({totalPages}, asap) => {
    const eta = totalPages;
    const etaIsOne = eta === 1;
    const etaIsAsap = asap.length;
    const etaTextSimple = etaIsOne ? 'up to 7 hours (during a business day)' : `${eta} business days`;
    const etaTextAsap = 'custom (turbo mode on)';
    const etaText = etaIsAsap ? etaTextAsap : etaTextSimple;
    const etaIsExists = !!eta;

    return {
      etaText,
      etaIsExists
    };
  }
);


